export interface GossipItem {
  id: string;
  title: string;
  year: string;
  tag: string;
  tagTone: "primary" | "accent" | "secondary";
  hot: number;
  summary: string;
  img: string;
}

export const featuredItems: GossipItem[] = [
  {
    id: "f1",
    title: "那一场“塌房”风暴，五年后重新复盘",
    year: "2019→2024",
    tag: "塌房旧账",
    tagTone: "accent",
    hot: 98,
    summary: "从顶流人设到一夜崩塌，我们顺着当年被埋进时间线的每一个节点，重新拼出这场连环反转的完整始末。",
    img: "https://readdy.ai/api/search-image?query=retro%20collage%20of%20a%20cracked%20golden%20statue%20with%20old%20newspaper%20clippings%2C%20warm%20orange%20and%20cream%20tones%2C%20vintage%20archive%20flat%20lay%2C%20dramatic%20editorial%20style&width=800&height=600&seq=gu1&orientation=landscape",
  },
  {
    id: "f2",
    title: "互撕三年终和解：一部剧引发的“世纪恩怨”",
    year: "2016→2019",
    tag: "团队纠纷",
    tagTone: "primary",
    hot: 87,
    summary: "抢番位、撕海报、发长文……两个剧组从开机吵到杀青，我们用档案把那些口水仗一条条归档。",
    img: "https://readdy.ai/api/search-image?query=vintage%20film%20clapperboard%20and%20two%20conflicting%20arrows%20on%20old%20paper%2C%20warm%20sepia%20archive%20collage%2C%20orange%20cream%20tone%2C%20editorial%20illustration&width=800&height=600&seq=gu2&orientation=landscape",
  },
  {
    id: "f3",
    title: "官宣即巅峰：这对“国民情侣”的爱情考古",
    year: "2015→2021",
    tag: "恋情时间线",
    tagTone: "accent",
    hot: 92,
    summary: "从被拍到公开到各自安好，我们把七年间那些甜与冷、真与假，按年份一点一点挖出来重新回看。",
    img: "https://readdy.ai/api/search-image?query=two%20silhouettes%20facing%20apart%20between%20faded%20love%20letters%20and%20hearts%20on%20aged%20paper%2C%20warm%20orange%20cream%20vintage%20archive%20style%2C%20editorial&width=800&height=600&seq=gu3&orientation=landscape",
  },
  {
    id: "f4",
    title: "直播间一夜爆火的顶流，如今人在何方",
    year: "2020→2023",
    tag: "网红考古",
    tagTone: "secondary",
    hot: 81,
    summary: "流量来得快去得也快，我们记录这位一夜封神的普通人，如何在三年里经历追捧、争议与沉寂。",
    img: "https://readdy.ai/api/search-image?query=vintage%20television%20with%20live%20broadcast%20waves%20and%20flickering%20screen%20on%20old%20newspaper%2C%20warm%20orange%20cream%20archive%20collage%2C%20editorial%20illustration&width=800&height=600&seq=gu4&orientation=landscape",
  },
];

export interface ArchiveCategory {
  name: string;
  count: number;
  desc: string;
  icon: string;
  tone: "primary" | "accent" | "secondary";
}

export const archiveCategories: ArchiveCategory[] = [
  { name: "恋情时间线", count: 128, desc: "官宣、分手、复合……逐年逐月归档明星恋情的来龙去脉。", icon: "ri-heart-3-line", tone: "accent" },
  { name: "塌房翻旧账", count: 86, desc: "人设崩塌名场面合集，还原每一个被埋没的细节。", icon: "ri-arrow-down-circle-line", tone: "primary" },
  { name: "选秀考古", count: 74, desc: "从超女快男到限定团，那些年我们追过的舞台旧料。", icon: "ri-mic-line", tone: "secondary" },
  { name: "饭圈战争", count: 63, desc: "控评、反黑、撕番位……饭圈大战的前因与后果。", icon: "ri-fire-line", tone: "accent" },
  { name: "合约纠纷", count: 52, desc: "解约风波与天价违约金，资本与艺人之间的博弈。", icon: "ri-file-shield-2-line", tone: "primary" },
  { name: "翻红史", count: 48, desc: "从过气到翻红，逆袭主角们的高光与低谷。", icon: "ri-arrow-up-line", tone: "secondary" },
  { name: "综艺名场面", count: 91, desc: "那些被盘包浆的综艺切片，背后的完整故事。", icon: "ri-tv-2-line", tone: "primary" },
  { name: "豪门家族瓜", count: 37, desc: "豪门恩怨、财产风波与家族浮沉的长线叙事。", icon: "ri-building-2-line", tone: "accent" },
];

export interface EraTimeline {
  era: string;
  label: string;
  points: {
    date: string;
    title: string;
    desc: string;
    tone: "primary" | "accent" | "secondary";
  }[];
}

export const timelineData: EraTimeline[] = [
  {
    era: "all",
    label: "全部旧账",
    points: [
      { date: "2013.04", title: "初代“国民CP”官宣", desc: "一条疑似恋情的曝光贴引爆全网，两人随后高调认爱。", tone: "accent" },
      { date: "2016.11", title: "合约纠纷首爆", desc: "经纪公司深夜发文，揭开一场持续两年的解约拉锯战。", tone: "primary" },
      { date: "2019.06", title: "直播顶流一夜爆火", desc: "素人主播凭一段即兴表演，观看人次当晚破千万。", tone: "secondary" },
      { date: "2021.09", title: "“塌房”风暴来袭", desc: "旧料被逐一翻出，人设与事实之间的裂缝越撕越大。", tone: "accent" },
    ],
  },
  {
    era: "2010s",
    label: "十年旧梦 2010s",
    points: [
      { date: "2010.08", title: "选秀黄金期巅峰", desc: "当年收视神话的背后，是草根一夜成名的集体狂欢。", tone: "secondary" },
      { date: "2013.04", title: "初代“国民CP”官宣", desc: "一条疑似恋情的曝光贴引爆全网，两人随后高调认爱。", tone: "accent" },
      { date: "2016.11", title: "合约纠纷首爆", desc: "经纪公司深夜发文，揭开一场持续两年的解约拉锯战。", tone: "primary" },
      { date: "2018.03", title: "“国民情侣”公开", desc: "狗仔蹲守数月拍到的画面，让一段地下恋情浮出水面。", tone: "accent" },
      { date: "2019.06", title: "直播顶流一夜爆火", desc: "素人主播凭一段即兴表演，观看人次当晚破千万。", tone: "secondary" },
    ],
  },
  {
    era: "2020s",
    label: "近年新瓜 2020s",
    points: [
      { date: "2020.10", title: "限定团成团即巅峰", desc: "出道夜的欢呼还没散，成员解约的传闻已经满天飞。", tone: "primary" },
      { date: "2021.09", title: "“塌房”风暴来袭", desc: "旧料被逐一翻出，人设与事实之间的裂缝越撕越大。", tone: "accent" },
      { date: "2022.07", title: "翻红主角回归", desc: "沉寂多年的过气艺人凭实力舞台逆袭，口碑反转。", tone: "secondary" },
      { date: "2024.05", title: "和解声明刷屏", desc: "僵持数年的双方罕见同框，一纸声明终结旧怨。", tone: "primary" },
    ],
  },
];

export interface FeatureArticle {
  id: string;
  eyebrow: string;
  title: string;
  lead: string;
  body: string[];
  readMin: number;
  img: string;
}

export const featureArticles: FeatureArticle[] = [
  {
    id: "a1",
    eyebrow: "编辑部特稿",
    title: "五年后重看：那场“塌房”教会了我们什么",
    lead: "当热度退潮、热搜被新的名字占据，真正值得被记住的，往往是那些被时间线层层掩埋的细节。",
    body: [
      "在吃瓜八卦考古的语境里，“塌房”从来不是一瞬的事。回看那条被反复转发的旧贴，事件早在三年前就有了苗头——只是当时没有人愿意深挖。",
      "我们把这段陈年往事按时间线拆开：被删除的声明、含糊的回应、深夜的秒删……每一个动作背后，都有可以追溯的轨迹。翻旧账的意义，正在于让人看清潮水退去前的涟漪。",
      "考古不是狂欢的续篇，而是一份冷静的档案。它提醒我们：吃瓜八卦旧料的价值，不只在爆料的刺激，更在于把一个完整的故事还给大家。",
    ],
    readMin: 9,
    img: "https://readdy.ai/api/search-image?query=wide%20retro%20editorial%20banner%20of%20scattered%20old%20newspaper%20pages%20and%20timeline%20dots%2C%20warm%20orange%20cream%20sepia%20tone%2C%20archival%20gossip%20investigation%20style&width=1200&height=500&seq=feat1&orientation=landscape",
  },
];

export const editorialQuote = {
  quote: "考古是一份档案，不是一场狂欢。",
  name: "《吃瓜考古社》编辑部",
};